var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fancy-heading"},[_c('h2',{staticClass:"fancy-heading__title"},[_vm._t("title")],2),(_vm.$slots.description !== undefined)?_c('p',{staticClass:"fancy-heading__description"},[_vm._t("description")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }